'use client';
var DEFAULT_COLOR_INVARIANTS = {
    white: {
        100: "rgba(255, 255, 255, 1.00)",
        70: "rgba(255, 255, 255, 0.7)",
        60: "rgba(255, 255, 255, 0.6)",
        50: "rgba(255, 255, 255, 0.5)",
        30: "rgba(255, 255, 255, 0.3)",
        15: "rgba(255, 255, 255, 0.15)",
        0: "rgba(0,0,0,0)"
    },
    black: {
        100: "rgba(0, 0, 0, 1.00)",
        70: "rgba(0, 0, 0, 0.7)",
        60: "rgba(0, 0, 0, 0.6)",
        50: "rgba(0, 0, 0, 0.5)",
        30: "rgba(0, 0, 0, 0.3)",
        15: "rgba(0, 0, 0, 0.1)",
        0: "rgba(0,0,0,0)"
    },
    neutral: {
        950: "#0E0F11",
        920: "#1D222B",
        900: "#222A37",
        700: "#323D4D",
        500: "#27344B",
        300: "#505F79",
        100: "#7A869A",
        80: "#95A0B3",
        60: "#D0D6E1",
        50: "#DDE3ED",
        40: "#ECEFF5",
        30: "#F1F3F8",
        20: "#F6F8FC"
    }
};

export { DEFAULT_COLOR_INVARIANTS };
